import React from 'react'
import Post from '../components/Post'

export default function CreatePage() {
  return (
    <div>
        <Post />
    </div>
  )
}
